module.exports = __webpack_public_path__ + "static/media/logoSchrift.dfc739c8.svg";